import { useContext } from 'react'
import Section from './_Section'
import Image from '../helpers/Image'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'
import { MarkupContext } from '../../providers/Markup'

function RatesCalculator(props) {
  const { detectPaletteClass, createMarkup } = useContext(MarkupContext)
  // not adding the boolean to the end output the length field 0 if there was no data.
  const right = props.rightTitle || props.linkItems?.length || false
  const stacked = props.layout === 'Single column'
  const componentPadding = transformPaddingToTailwind(props.componentPadding)
  
  // Handle content alignment (left/center/right) from Component Configuration
  const alignment = props.contentAlignment?.toLowerCase() || 'center'
  const textAlignClass = alignment === 'center' ? 'text-center' : alignment === 'right' ? 'text-right' : 'text-left'
  // Only use mx-auto for center alignment when stacked or no right column, otherwise let text alignment handle it
  const containerAlignClass = alignment === 'center' ? 'mx-auto' : ''
  // For side-by-side layout with center alignment, apply mx-auto and max-width to flex container
  const flexContainerAlignClass = !stacked && right && alignment === 'center' ? 'mx-auto max-w-7xl' : ''

  return (
    <Section type="ratesCalculator" outerClass={componentPadding} sectionTitle={false} innerClass="px-6" {...props}>
      <div className={`flex max-lg:flex-col gap-14 ${stacked ? 'flex-wrap' : ''} ${flexContainerAlignClass}`}>
        <div
          className={`${!right || stacked ? `lg:basis-3/5 basis-full ${containerAlignClass}` : 'lg:basis-3/5'} ${textAlignClass}`}
        >
          {(props.title || props.description) && <TitleBlock {...props} headingClass={textAlignClass} />}

          {props.url && <iframe src={props.url} className="mt-4 w-full" height="684" />}
        </div>
        {right && (
          <div className={`${!right || stacked ? `lg:basis-3/5 basis-full ${containerAlignClass}` : 'lg:basis-2/5'} ${textAlignClass}`}>
            {props.rightTitle && (
              <div
                className={`${textAlignClass} text-2xl font-bold`}
                data-rte="true"
                dangerouslySetInnerHTML={createMarkup(props.rightTitle)}
              />
            )}
            {props.linkItems?.length
              ? props.linkItems.map((linkItem, i) => {
                  return (
                    <a
                      key={i}
                      href={linkItem.link?.url}
                      className={detectPaletteClass('flex gap-3 items-center mt-4 px-6 lg:px-10 xl:px-12 py-6 md:py-6 border-2 border-gray-100 bg-gray-50 rounded-md text-xl font-bold')}
                    >
                      {linkItem.linkImage && (
                        <span className={`${stacked ? 'basis-1/5 lg:basis-1/12' : 'basis-1/5'} grow-0`}>
                          <Image {...linkItem.linkImage} className="w-full h-auto mx-auto aspect-square rounded-none" />
                        </span>
                      )}
                      <span className={`${stacked ? 'basis-3/4 lg:basis-11/12' : 'basis-3/4'} shrink-0`}>
                        {linkItem.link?.name}
                      </span>
                    </a>
                  )
                })
              : null}
          </div>
        )}
      </div>
    </Section>
  )
}

export default RatesCalculator
